import React, { Component } from 'react';
import styles from './styles.scss';
import classNames from 'classnames';
import { shape, string, number, bool } from 'prop-types';

export default class GeoTableSummary extends Component {
  static propTypes = {
    summaryData: shape({
      title: string,
      totalAdVisits: number,
      totalAds: number,
      totalVisitsPerAd: number,
      uniqueAds: number,
    }),
    isAvgCostDisabled: bool,
    title: string
  }

  static defaultProps = {
    title: 'Grand Total'
  }

  render() {
    const { title, summaryData, isAvgCostDisabled } = this.props;
    const { totalAdVisits, totalAds, uniqueAds = 0, totalAdCost, numPricedAds } = summaryData;
    const formattedTotalAdVisits = Math.round(totalAdVisits);
    const totalVisitsPerAd = totalAds? parseFloat((totalAdVisits/totalAds).toFixed(2)).toLocaleString() : 0;
    const avgAdCost = numPricedAds? parseFloat(totalAdCost/ numPricedAds).toFixed(2).toLocaleString() : `0.00`;
    const uniqueAdLabel = `${uniqueAds.toLocaleString()} Unique Ads`;

    return (
      <div className={classNames(styles.tableRow, styles.summaryRow)}>
        <div data-test="summaryName" className={classNames(styles.tableCell, styles.summaryCellTitle)}>{title}</div>
        <div data-test="summaryAdVisits" className={classNames(styles.tableCell, styles.summaryCell)}>{formattedTotalAdVisits.toLocaleString()}</div>
        <div className={classNames(styles.tableCell, styles.summaryCell)}>
          <div className={styles.adsContainer}>
            <span data-test="summaryAds" className={styles.adsValue}>
              {totalAds.toLocaleString()}
            </span>
            <div data-test="summaryAdsLabel" className={styles.uniqueContainer}>
              {uniqueAdLabel}
            </div>
          </div>
        </div>
        <div data-test="summaryVisitsAds" className={classNames(styles.tableCell, styles.summaryCell)}>{totalVisitsPerAd}</div>
        { !isAvgCostDisabled && <div data-test="summaryAdCost" className={classNames(styles.tableCell, styles.summaryCell)}>${avgAdCost}</div>}
      </div>
    )
  }
};
